import { useState, useEffect } from 'react'
import { signIn, signUp, signInWithGoogle, getCurrentUser } from '../services/firebaseService'
import '../styles/components/auth-modal.css'

function AuthModal({ isOpen, onClose, onSuccess, mode = 'signin' }) {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [currentMode, setCurrentMode] = useState(mode)

  useEffect(() => {
    setCurrentMode(mode)
  }, [mode])

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)

    if (currentMode === 'signup' && password !== confirmPassword) {
      setError('Adgangskoder matcher ikke')
      setLoading(false)
      return
    }

    if (password.length < 6) {
      setError('Adgangskode skal være mindst 6 tegn')
      setLoading(false)
      return
    }

    try {
      let result
      if (currentMode === 'signup') {
        result = await signUp(email, password, 'parkort')
      } else {
        result = await signIn(email, password, 'parkort')
      }

      if (result.success) {
        onSuccess(result.user)
        onClose()
      } else {
        setError(result.error || 'Noget gik galt')
      }
    } catch (err) {
      setError(err.message || 'Noget gik galt')
    } finally {
      setLoading(false)
    }
  }

  const handleGoogleSignIn = async () => {
    setError('')
    setLoading(true)
    try {
      const result = await signInWithGoogle('parkort')
      if (result.success) {
        onSuccess(result.user)
        onClose()
      } else {
        setError(result.error || 'Noget gik galt')
      }
    } catch (err) {
      setError(err.message || 'Noget gik galt')
    } finally {
      setLoading(false)
    }
  }

  if (!isOpen) return null

  return (
    <div className="auth-overlay" onClick={onClose}>
      <div className="auth-modal" onClick={(e) => e.stopPropagation()}>
        <button className="auth-close" onClick={onClose} aria-label="Luk">
          ×
        </button>

        <div className="auth-header">
          <h2>{currentMode === 'signup' ? 'Opret konto' : 'Log ind'}</h2>
          <p>
            {currentMode === 'signup' 
              ? 'Opret en konto for at få adgang til Premium på alle dine enheder'
              : 'Log ind for at få adgang til Premium på alle dine enheder'}
          </p>
        </div>

        {error && (
          <div className="auth-error">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="auth-input-group">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="din@email.com"
              required
              disabled={loading}
            />
          </div>

          <div className="auth-input-group">
            <label htmlFor="password">Adgangskode</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder={currentMode === 'signup' ? 'Mindst 6 tegn' : 'Din adgangskode'}
              required
              disabled={loading}
              minLength={6}
            />
          </div>

          {currentMode === 'signup' && (
            <div className="auth-input-group">
              <label htmlFor="confirmPassword">Bekræft adgangskode</label>
              <input
                id="confirmPassword"
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Gentag adgangskode"
                required
                disabled={loading}
                minLength={6}
              />
            </div>
          )}

          <button 
            type="submit" 
            className="auth-submit-btn"
            disabled={loading}
          >
            {loading ? 'Venter...' : (currentMode === 'signup' ? 'Opret konto' : 'Log ind')}
          </button>
        </form>

        <div className="auth-divider">
          <span>eller</span>
        </div>

        <button 
          className="auth-google-btn"
          onClick={handleGoogleSignIn}
          disabled={loading}
        >
          <span>🔵</span> Fortsæt med Google
        </button>

        <div className="auth-footer">
          {currentMode === 'signup' ? (
            <p>
              Har du allerede en konto?{' '}
              <button 
                type="button"
                className="auth-link-btn"
                onClick={() => setCurrentMode('signin')}
              >
                Log ind
              </button>
            </p>
          ) : (
            <p>
              Har du ikke en konto?{' '}
              <button 
                type="button"
                className="auth-link-btn"
                onClick={() => setCurrentMode('signup')}
              >
                Opret konto
              </button>
            </p>
          )}
        </div>
      </div>
    </div>
  )
}

export default AuthModal
